module.exports = __webpack_public_path__ + "static/media/2019-05-18.021274ce.md";